export default __webpack_public_path__ + "static/media/yaroslavl_products.20da072f.jpg";